(function() {
	'use strict';

	angular.module('widgets.initiative')
	.service('leanProjectProgressSummaryService', leanProjectProgressSummaryService);

	function leanProjectProgressSummaryService($http, URLS) {
		return {
			getLeanProjectProgressSummary: getLeanProjectProgressSummary
		};

		function getLeanProjectProgressSummary(filterService) {
			var factories = filterService.getFactoryList();
			var url = URLS.host + URLS.prefix + factories + '/LeanProjectProgressSummary';
			url = filterService.addFilterQueryParams(url);
			return $http.get(url)
				.then(getProjectsTargetVsActualComplete)
				.catch(getProjectsTargetVsActualFailed);

			function getProjectsTargetVsActualComplete(response) {
				return response.data;
			}
			function getProjectsTargetVsActualFailed(error) {
				return error;
			}
		}
	}
})();